module.exports = __webpack_public_path__ + "6ee29c92afa4ddb95ad25e8386cd7eda.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/audio/area.mp3
 ** module id = 640
 ** module chunks = 0
 **/